import { useState, useEffect } from "react";
import Layout from "../../../layout/Layout";
import { useNavigate } from "react-router-dom";

import {
  deleteBlogById,
  FeaturedBlogs,
} from "../../../redux/slice/blog/blogThunk";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import BlogTable from "../blog-details/components/BlogTable";

const BlogFeatured = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { featuredBlogs, loading } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(FeaturedBlogs())
      .unwrap()
      .catch(() => {
        toast.error("Failed to load blogs");
      });
  }, [dispatch]);

  const handleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this blog?"
    );
    if (!confirmed) return;

    try {
      await dispatch(deleteBlogById(id)).unwrap();
      await dispatch(FeaturedBlogs()).unwrap();
      toast.success("Blog deleted successfully");
    } catch (error) {
      toast.error("Failed to delete blog");
    }
  };

  const handleEdit = (id) => {
    navigate(`/blog-details/edit/${id}`);
  };

  const handleView = (id) => {
    navigate(`/blog-details/view/${id}`);
  };

  return (
    <Layout>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h3 className="h3">Featured Blog</h3>
      </div>

      <div className="space-y-6">
        {/* Search and Filter */}

        {/* Blog Table or Fallback */}
        {loading ? (
          <p className="text-center text-muted py-5">
            Loading featured blogs...
          </p>
        ) : featuredBlogs.length ? (
          <BlogTable
            data={featuredBlogs}
            onEdit={handleEdit}
            onView={handleView}
            onDelete={handleDelete}
          />
        ) : (
          <div className="text-center text-muted py-5">
            No blogs found for the current filters.
          </div>
        )}
      </div>
    </Layout>
  );
};

export default BlogFeatured;
